import React, {createContext} from "react";

const CalculationContext = createContext({});
export default CalculationContext;

CalculationContext.displayName = "CalculationContext";
